import { isObject } from '~/utils/v'

export default {
  computed: {
    getPage () {
      return this.page
    },
    getPageData () {
      return this.getPage.data
    },
    hasPage () {
      return isObject(this.getPage) ? !!Object.keys(this.getPage).length : false
    },
    getPageTitle () {
      return this.getPageData.title
    },
    getPageSubTitle () {
      return this.getPageData.subtitle
    },
    getPageContent () {
      return this.getPageData.content
    },
    getPageFAQ () {
      return this.getPage.faqs
    },
    hasPageFAQ () {
      return this.getPageFAQ?.length
    },
    getPageSections () {
      return this.getPage.sections
    }
  }
}
